import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";   // redux-thunk latest = named export
import { composeWithDevTools } from "@redux-devtools/extension"; // 👈 new package
import rootReducer from "./reducer";

const middleware = [thunk];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
